import React from "react";

import FlagSprite from "../FlagSprite";
import Icon from "../Icon";
import Modal from "../Modal";
import ModalFooterCloseBtn from "../ModalFooterCloseBtn";

export default class LeveledUpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
  }

  getShareText() {
    return 'I just leveled up playing Clozemaster! Now at level ' + this.props.level + ' learning ' + this.props.targetLanguageEnglishName + ' from ' + this.props.baseLanguageEnglishName + '. ' + this.props.shareUrl;
  }

  onShareClick() {
    navigator.share({
      title: 'Leveled up playing Clozemaster!',
      text: this.getShareText(),
      url: this.props.shareUrl
    }).catch(() => {});
  }

  onCopyClick() {
    navigator.clipboard.writeText(this.getShareText()).then(() => {
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2000);
    });
  }

  render() {
    const canShare = typeof navigator.share === 'function';
    const { copied } = this.state;

    return (
      <Modal
        footer={<ModalFooterCloseBtn />}
        id="levelup-modal"
        ref={(el) => this.modal = el}
        size="small"
        title="Leveled Up!"
      >
        <div className="text-center" ref={(el) => this.content = el}>
          <div className="challenge levelup" style={{ display: 'block' }}>
            <div className="title joystix">
              <FlagSprite flagIso={this.props.targetLanguageFlagIso} /> / <FlagSprite flagIso={this.props.baseLanguageFlagIso} />
              <div>Level:</div>
            </div>
            <div className="value">
              <div className="level">{this.props.level}</div>
              <div className="plus">+1<span className="glyphicon glyphicon-arrow-up"></span></div>
            </div>
          </div>
          <img src={this.props.imagePath} style={{ maxWidth: 250 }} />
          <h3>Tell the world!</h3>
          <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
            {canShare && (
              <button className="btn btn-success btn-block joystix btn-lg" onClick={() => this.onShareClick()}>
                <Icon name="share" type="fa" /> Share
              </button>
            )}
            <button className="btn btn-default btn-sm" onClick={() => this.onCopyClick()}>
              <Icon name="copy" type="fa" /> {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
